import axios from 'axios';
import { createTruckQuery } from './queries';

const addTruck = (model) =>
    new Promise((resolve, reject) => {
        const query = createTruckQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add truck'));
            });
    });

export default addTruck;
